import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
const REFLECTOR_ADMIN_URL = `${API_BASE_URL}/v2/reflector-admin`;

function authHeader(token: string) {
  return { headers: { Authorization: `Bearer ${token}` } };
}

export interface AdminReflectorOption {
  subId: string;
  name: string;
  tenantName: string;
}

export async function getAllReflectorsAdmin(token: string): Promise<AdminReflectorOption[]> {
  const { data } = await axios.get<
    { subId: string; name: string; tenant?: { Name?: string; nameDisplay?: string } }[]
  >(`${REFLECTOR_ADMIN_URL}/instances`, authHeader(token));
  return (data ?? []).map((r) => ({
    subId: r.subId ?? "",
    name: r.name ?? "",
    tenantName: r.tenant?.nameDisplay ?? r.tenant?.Name ?? "",
  }));
}

export type SystemAction = "status" | "stop" | "restart";

export interface ServiceResult {
  exit_code: number;
  output: string;
  error: string;
}

export interface SystemStatusResult {
  requestId: string;
  ctxrUuid: string;
  action: SystemAction;
  services: string[];
  output: Record<string, ServiceResult>;
  respondedAt: string;
}

export interface SystemActionPayload {
  ctxrUuid: string;
  services?: string[];
}

export async function getDefaultServices(token: string): Promise<string[]> {
  const { data } = await axios.get<{ success: boolean; data: string[] }>(
    `${REFLECTOR_ADMIN_URL}/system-status/services`,
    authHeader(token)
  );
  return data.data;
}

export async function fetchSystemStatus(
  payload: SystemActionPayload,
  token: string
): Promise<SystemStatusResult> {
  const { data } = await axios.post<{ success: boolean; data: SystemStatusResult }>(
    `${REFLECTOR_ADMIN_URL}/system-status/fetch`,
    payload,
    authHeader(token)
  );
  return data.data;
}

export async function sendServiceStop(
  payload: SystemActionPayload,
  token: string
): Promise<SystemStatusResult> {
  const { data } = await axios.post<{ success: boolean; data: SystemStatusResult }>(
    `${REFLECTOR_ADMIN_URL}/system-status/stop`,
    payload,
    authHeader(token)
  );
  return data.data;
}

export async function sendServiceRestart(
  payload: SystemActionPayload,
  token: string
): Promise<SystemStatusResult> {
  const { data } = await axios.post<{ success: boolean; data: SystemStatusResult }>(
    `${REFLECTOR_ADMIN_URL}/system-status/restart`,
    payload,
    authHeader(token)
  );
  return data.data;
}
